<template>
  <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general m-stack--fluid">
    <div class="m-stack__item m-topbar__nav-wrapper">

      <ul class="m-topbar__nav m-nav m-nav--inline">
        <!-- begin: notifications -->
        <li
          class="m-nav__item m-topbar__notifications
          m-topbar__notifications--img m-dropdown m-dropdown--medium m-dropdown--header-bg-fill m-dropdown--arrow
          m-dropdown--align-right  m-dropdown--notifications"
          :m-dropdown-toggle="'click'"
          :m-dropdown-persistent="'0'">

          <a href="javascript:" class="m-nav__link m-dropdown__toggle" id="m_topbar_notification_icon">

            <span v-if="numberOfNotifications > 0"
                  :class="{ 'm-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger':true,
                  'm-animate-blink':numberOfNotifications > 0}"></span>
            <span :class="{ 'm-nav__link-icon':true, 'm-animate-shake':numberOfNotifications > 0}" class="m-nav__link-icon">
                        <i class="flaticon-alarm"></i>
                      </span>
          </a>

          <div class="m-dropdown__wrapper" >
            <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>

            <div class="m-dropdown__inner">
              <div class="m-dropdown__header m--align-center"
                   :style="'background: url('+cdn_url+'/img/misc/notification_bg_blue.jpg); background-size: cover;'">
                <span class="m-dropdown__header-subtitle">{{$t('menus.quick.UserNotifications')}}</span>
              </div>

              <div class="m-dropdown__body">
                <div class="m-dropdown__content">

                  <div class="m-scrollable" data-scrollable="true" data-height="250" data-mobile-height="200"
                       id="notificationList">
                    <div class="m-list-timeline m-list-timeline--skin-light">

                      <div class="m-list-timeline__items">

                        <div class="m-list-timeline__item" v-if="numberOfNotifications == 0">
                          {{$t('menus.quick.NoNotifications')}}
                        </div>

                        <div class="m-list-timeline__item" v-if="drafts.length > 0">
                          <span class="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
                          <span class="m-list-timeline__text">
                            <router-link :to="getLinkToProperties"
                                         class="m-nav-grid__item">
                              {{$t('notification.DraftProperty', { total: drafts.length })}}
                            </router-link>
                          </span>

                          <div class="m-nav__separator m-nav__separator--dashed"></div>
                        </div>

                        <div class="m-list-timeline__item" v-if="noFeaturedProperty">
                          <span class="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
                          <span class="m-list-timeline__text">
                            <router-link
                            :to="{ name: 'Advertise'}" class="m-nav-grid__item">
                              {{$t('notification.NoFeaturedProperty')}}
                            </router-link>
                          </span>
                          <div class="m-nav__separator m-nav__separator--dashed"></div>
                        </div>

                        <div class="m-list-timeline__item" v-if="noFeaturedBusiness">
                          <span class="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
                          <span class="m-list-timeline__text">
                            <router-link
                              :to="{ name: 'AdvertiseDir'}" class="m-nav-grid__item">
                                         {{$t('notification.NoFeaturedBusiness')}}
                            </router-link>
                          </span>
                          <div class="m-nav__separator m-nav__separator--dashed"></div>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- end: notifications -->

        <!-- begin: usermenu -->
        <li
          class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right  m-dropdown--skin-light m-dropdown--profile"
          :m-dropdown-toggle="'click'"
          id="userProfileMenu">
          <a href="javascript:" class="m-nav__link m-dropdown__toggle" id="userProfileMenuLink">
            <span class="m-topbar__userpic">
               <span class="m-type m--bg-brand">
                    <span class="m--font-light">{{ firstLetter }}</span>
               </span>
            </span>
            <span class="m-topbar__username m--hide">Nick</span>
          </a>
          <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
            <div class="m-dropdown__inner" style="max-height: calc(100vh - 160px);overflow-y: auto;">
              <div class="m-dropdown__header m--align-center"
                   :style="'background-image: url('+cdn_url+'/img/misc/user_profile_bg_blue.jpg); background-size: cover;'">
                <div class="m-card-user m-card-user--skin-dark">
                  <div class="m-card-user__pic">
                    <span class="m-type m--bg-light">
                        <span class="m--font-brand">{{ firstLetter }}</span>
                    </span>
                  </div>
                  <div class="m-card-user__details">
                    <span class="m-card-user__name m--font-weight-500 m--font-light d-inline-block text-truncate mt-4"
                          style="max-width: 180px;">{{fullName}}</span>
                    <div class="clearfix"></div>
                    <span
                      class="m-card-user__email m--font-weight-300 m--font-light m-link d-inline-block text-truncate"
                      style="max-width: 180px;">{{email}}</span>
                    <div class="clearfix"></div>
                    <span
                        class="m--font-weight-300 m--font-light d-inline-block"
                        style="max-width: 180px;"><small>{{login}}</small></span>
                  </div>
                </div>
              </div>
              <div class="m-dropdown__body">
                <div class="m-dropdown__content">
                  <ul class="m-nav m-nav--skin-light">

                    <router-link tag="li" :to="{ name: 'Advertise'}" active-class="m-nav__item--active"
                                 class="m-nav__item">
                      <router-link :to="{ name: 'Advertise'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-line-graph"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseProperty")}}</span>
                          </span>
                        </span>
                      </router-link>
                    </router-link>

                    <router-link tag="li" :to="{ name: 'AdvertiseDir'}" active-class="m-nav__item--active"
                                 class="m-nav__item">
                      <router-link :to="{ name: 'AdvertiseDir'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-line-graph"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseDirectory")}}</span>
                          </span>
                        </span>
                      </router-link>
                    </router-link>

                    <li active-class="m-nav__item--active" class="m-nav__item">
                      <a :href="orderStickerLink()" class="m-nav__link" target="_blank">
                        <i class="m-nav__link-icon flaticon-notes"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.OrderStickers") }}</span>
                          </span>
                        </span>
                      </a>
                    </li>

                    <li active-class="m-nav__item--active" class="m-nav__item">
                      <a href="https://www.thinkspain.com/advertise/job" class="m-nav__link" target="_blank">
                        <i class="m-nav__link-icon flaticon-suitcase"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("advertise.AdvertiseJob")}}</span>
                          </span>
                        </span>
                      </a>
                    </li>

                    <li class="m-nav__separator m-nav__separator--dashed "></li>

                    <router-link tag="li" :to="{ name: 'Invoicing'}" active-class="m-nav__item--active"
                                 class="m-nav__item">
                      <router-link :to="{ name: 'Invoicing'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-piggy-bank"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("menus.user.invoicing")}}</span>
                          </span>
                        </span>
                      </router-link>
                    </router-link>

                    <router-link tag="li" :to="{ name: 'TermsOfService'}" active-class="m-nav__item--active"
                                 class="m-nav__item">
                      <router-link :to="{ name: 'TermsOfService'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-exclamation-1"></i>
                        <span class="m-nav__link-title">
                          <span class="m-nav__link-wrap">
                              <span class="m-nav__link-text">{{ $t("menus.user.termsofservice")}}</span>
                          </span>
                        </span>
                      </router-link>
                    </router-link>

                    <router-link tag="li" :to="{ name: 'Support'}" active-class="m-nav__item--active"
                                 class="m-nav__item">
                      <router-link :to="{ name: 'Support'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-support"></i>
                        <span class="m-nav__link-text">{{ $t("common.support")}}</span>
                      </router-link>
                    </router-link>

                    <router-link v-if="false" tag="li" :to="{ name: 'FAQ'}" active-class="m-nav__item--active" class="m-nav__item">
                      <router-link :to="{ name: 'FAQ'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-exclamation-2"></i>
                        <span class="m-nav__link-text">{{ $t("common.faq")}}</span>
                      </router-link>
                    </router-link>

                    <li class="m-nav__separator m-nav__separator--dashed "></li>

                    <li class="m-nav__item">
                      <router-link :to="{ name: 'Logout'}" class="m-nav__link">
                        <i class="m-nav__link-icon flaticon-logout"></i>
                        <span class="m-nav__link-text">{{ $t("menus.user.logout")}}</span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- begin: usermenu -->

        <!-- begin: language -->
        <li
          class="m-nav__item m-topbar__languages m-dropdown m-dropdown--small m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right  m-dropdown--languages"
          :m-dropdown-toggle="'click'">
          <a href="javascript:" class="m-nav__link m-dropdown__toggle">
            <span class="m-nav__link-text">
                <img id="language_flag"
                     alt=""
                     class="m-topbar__language-selected-img"
                     :src="currentFlag">
            </span>
          </a>
          <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
            <div class="m-dropdown__inner">
              <div class="m-dropdown__header m--align-center"
                   :style="'background-image: url('+cdn_url+'/img/misc/quick_actions_bg_blue.jpg); background-size: cover;'">
                <span class="m-dropdown__header-subtitle">{{$t('common.picklanguage')}}</span>
              </div>
              <div class="m-dropdown__body">
                <div class="m-dropdown__content">
                  <ul class="m-nav m-nav--skin-light">

                    <li v-for="(language, index) of ['en', 'es']" :key="index" :class="{'m-nav__item': true, 'm-nav__item--active': isActiveLanguage(language)}">
                      <template v-if="!isActiveLanguage(language)">
                        <a href="javascript:"
                           :class="{'m-nav__link':true, 'm-nav__link--active':false}"
                           @click="setLocale(language)">
                          <span class="m-nav__link-icon">
                            <img
                              class="m-topbar__language-img"
                              alt=""
                              :src="flagFor(language)">
                          </span>
                          <span class="m-nav__link-title m-topbar__language-text m-nav__link-text">
                            {{ $t('lang.' + language)}}
                          </span>
                        </a>
                      </template>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- begin: language -->

      </ul>

    </div>
  </div>
</template>

<script>
  import Cookie from "js-cookie"
  import functions from '@/plugins/functions'
  import {clientapi} from '@/interceptors/clientapi'

  const flags = {
    es: process.env.CDN_URL+'/img/flags/spain.svg',
    en: process.env.CDN_URL+'/img/flags/uk.svg'
  };

  export default {
    name: 'top-bar',
    data() {
      return {
        cdn_url: process.env.CDN_URL,
        user: {},
        propertyService: {},
        featuredService: {},
        directoryService: {},
        drafts: [],
        languages: []
      }
    },
    computed: {
      noFeaturedProperty() {
        return this.propertyService.Status == 'ACTIVE' && this.featuredService.MaxFeaturedPremium == 0 && this.featuredService.MaxFeaturedStandard == 0
      },
      noFeaturedBusiness(){
        return this.directoryService.Featured == 0 && this.directoryService.FeaturedPremium == 0
      },
      firstLetter(){
        let user = this.user
        if (!user || !user.Name || user.Name.length == 0){
          return '?'
        }

        return user.Name[0]
      },
      numberOfNotifications(){
        let count = 0
        if (this.noFeaturedProperty) {
          count++
        }
        if (this.noFeaturedBusiness) {
          count ++
        }

        if (this.drafts.length > 0){
          count++
        }
        return count
      },
      fullName() {
        return this.user.TradeName || this.user.CompanyName
      },
      email(){
        return this.user.Email
      },
      login(){
        return this.user.Login
      },
      currentFlag() {
        return flags[this.$i18n.locale || 'es']
      },
      getLinkToProperties(){
        let queryCopy = this.$utils.cloneObject(this.$route.query)
        queryCopy['action'] = 'openPI'
        if (this.$route.name === 'Properties')
          return { name: 'Properties', query: queryCopy}

        return {name: 'Properties',query: {
          action: 'openPI'
          }}
      },
      canSeeProperty() {
        let status = this.propertyService.Status
        return ['ACTIVE', 'ACTIVE_PENDING', 'ACTIVE_EXPIRED'].includes(status)
      },
    },
    methods: {
      flagFor(lang){
        return flags[lang]
      },
      isActiveLanguage(codeLang) {
        return this.$i18n.locale === codeLang
      },
      setLocale: function (locale) {
        Cookie.set('locale', locale,{expires: 14, sameSite: 'Strict'})
        this.$i18n.locale = locale
        this.$router.go()
      },
      async getDrafts(){
        let response = await clientapi.get('/items', { params: { type: 'new-property' } })

        if (response.status != 200){
          return
        }

        if (response.data) {
          this.drafts = response.data.filter(r => r.Content != null)
        }

      },
      orderStickerLink() {
        return `https://www.thinkspain.com/${this.$i18n.locale === 'es' ? 'es/': ''}order-window-stickers?login=${this.user.Login}`
      }
    },
    async mounted() {
      this.user = functions.getUser()
      let propertyServiceCall = functions.getPropertyService()
      let featuredServiceCall = functions.getFeaturedService()
      let directoryServiceCall = functions.getDirectoryService()

      this.getDrafts()

      this.propertyService = await propertyServiceCall
      this.directoryService = await directoryServiceCall
      this.featuredService = await featuredServiceCall
    }
  }


</script>



// WEBPACK FOOTER //
// src/components/dashboard/common/menus/TopBar.vue